import React from 'react';
import ClientAddressesEditButton from './ClientAddressesEditButton';

const ClientAddressesCell = (params) => {
    const id = params.row.address_id;

    if (params.field === 'address_edit') {
        return <ClientAddressesEditButton id={id} />;
    }

    return <>{params.value ?? ''}</>;
};

export default ClientAddressesCell;
